import { CommandController } from './../../commanding/CommandController';
/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: Patrick
 * Created: 26.06.12, 14:38
 *
 * $URL$
 * $Rev$
 * $Author$
 * $Date$
 * $Id$
 */


import { BasicController } from "../controller/BasicController";
import { ConnectionTrackingCommandVO } from "../controller/clientCommands/tracking/vo/ConnectionTrackingCommandVO";
import { BasicModel } from "../model/BasicModel";
import { bind } from "../utils/bind";
import TimerEvent = createjs.TimerEvent;
import { Timer } from "@goodgamestudios/createjs-utilities";

/**
 * Handles ConnectionTrackingEvent.
 * The ConnectionTrackingEvent will be fire once after the connection establishing with the smartfox server and a second time
 * 60s after the REGISTERED
 */
export class ConnectionTrackingUtil {
    public static SECOND_CONNECTION_EVENT_DELAY: number = 60000;
    public static THIRD_CONNECTION_EVENT_DELAY: number = 120000;

    private static _instance: ConnectionTrackingUtil;

    private _timers: Timer[] = new Array<Timer>();

    public static get instance(): ConnectionTrackingUtil {
        if (!ConnectionTrackingUtil._instance) {
            ConnectionTrackingUtil._instance = new ConnectionTrackingUtil();
        }

        return ConnectionTrackingUtil._instance;
    }

    public measureRTT(delay: number): void {
        this.startTimer(delay);
    }

    private timerCompleteHandler(e: TimerEvent): void {
        let timer: Timer = (<Timer>e.target);
        this.disposeTimer(timer);

      //  BasicModel.smartfoxClient.onRoundTripResponse.addOnce(bind(this.rttResponseHandler, this, timer.delay));
        // TODO @HTML5  we need to be able to pass params to the bind function WE MIGHT NOT EVEN NEED THIS , SINCE IT'S BLUEBOX RELATED
        BasicModel.smartfoxClient.roundTripResponseSignal.addOnce(this.rttResponseHandler.bind(this, timer.delay));
       // BasicModel.smartfoxClient.onRoundTripResponse.addOnce(this.bindFunction(this.rttResponseHandler));
        BasicModel.smartfoxClient.executeRoundTrip();
    }

    private rttResponseHandler(delay: number, roundTripTime: number, bluebox: number): void {
        CommandController.instance.executeCommand(
            BasicController.COMMAND_TRACK_CONNECTION_TRACKING_EVENT,
            new ConnectionTrackingCommandVO(
                delay,
                roundTripTime.toString(),
                bluebox
            )
        );
    }

    private startTimer(delay: number): void {
        let timer: Timer = new Timer(delay, 1);
        timer.addEventListener(TimerEvent.TIMER_COMPLETE, this.bindFunction(this.timerCompleteHandler));
        timer.start();
        this._timers.push(timer);
    }

    private disposeTimer(timer: Timer): void {
        let index: number = this._timers.indexOf(timer);
        if (index != -1) {
            timer = this._timers.splice(index, 1)[0];
            timer.removeEventListener(TimerEvent.TIMER_COMPLETE, this.bindFunction(this.timerCompleteHandler));
            timer.stop();
        }
    }

    public dispose(): void {
        BasicModel.smartfoxClient.roundTripResponseSignal.removeAll();
        while (this._timers.length) {
            this.disposeTimer(this._timers[0]);
        }
    }
}

